import { render, staticRenderFns } from "./ServiceClinicCardSkeleton.vue?vue&type=template&id=3adce783&scoped=true&"
import script from "./ServiceClinicCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./ServiceClinicCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ServiceClinicCardSkeleton.vue?vue&type=style&index=0&id=3adce783&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adce783",
  null
  
)

export default component.exports